<template>
  <div class="logo">
    <router-link
      to="/"
      title="Главная"
    >
      <img
        src="/static/images/logo/logo.svg"
        alt="Ювелирная фирма «Стиль»"
        width="220"
        height="95"
      >
    </router-link>
  </div>
</template>

<script>
export default {
  name: 'Logo',
  data: function () {
    return {}
  }
}
</script>

<style scoped lang="scss">
  .logo {
    margin: 2.5em auto;
    & > a {
      display: block;
      & > img {
        display: block;
        opacity: 0.8;
        width: 300px;
        height: auto;
        transition: opacity 0.3s ease;
        &:hover { opacity: 1; }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/the-footer/Logo.vue